import { Component } from 'react';
import text from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Button } from 'foundations-components/transitional/components/Button';
import shallowCompare from 'react-addons-shallow-compare';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.addRedirectUrlModal.${key}`;
const VALID_URL_REGEX = new RegExp(/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/);
export default function withAddRedirectModal(WrappedComponent) {
  class AddRedirectUrlModal extends Component {
    constructor(props) {
      super(props);
      this.onModalOpen = this.onModalOpen.bind(this);
      this.onModalClose = this.onModalClose.bind(this);
      this.onModalConfirm = this.onModalConfirm.bind(this);
      this.onUrlChange = this.onUrlChange.bind(this);
      this.onUrlBlur = this.onUrlBlur.bind(this);
      this.checkValidation = this.checkValidation.bind(this);
      const {
        value
      } = props;
      const {
        redirect_url: redirectUrl = ''
      } = !value || typeof value === 'string' ? {} : value;
      this.state = {
        open: false,
        url: redirectUrl,
        isValidUrl: true
      };
    }
    shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    }
    onModalOpen() {
      this.setState({
        open: true
      });
    }
    onModalClose() {
      this.setState({
        open: false
      });
    }
    onModalConfirm() {
      this.onModalClose();
      this.props.onFieldChange(Object.assign({}, this.props.value, {
        redirect_id: null,
        redirect_url: this.state.url
      }));
    }
    onUrlChange(e) {
      const url = e.target.value;
      this.setState({
        url
      });
      this.checkValidation(url);
    }
    onUrlBlur() {
      this.checkValidation(this.state.url);
    }
    checkValidation(url) {
      this.setState({
        isValidUrl: !url || VALID_URL_REGEX.test(url)
      });
    }
    renderModal() {
      const {
        open,
        url,
        isValidUrl
      } = this.state;
      if (!open) {
        return null;
      }
      const validationMessage = !isValidUrl && /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('invalidUrlMessage')
      });
      return /*#__PURE__*/_jsxs(Modal, {
        width: 600,
        children: [/*#__PURE__*/_jsxs(DialogHeader, {
          children: [/*#__PURE__*/_jsx(DialogCloseButton, {
            onClick: this.onModalClose
          }), /*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('header')
            })
          })]
        }), /*#__PURE__*/_jsxs(DialogBody, {
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('message')
            })
          }), /*#__PURE__*/_jsx(FormControl, {
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('input.label')
            }),
            error: Boolean(url && !isValidUrl),
            validationMessage: validationMessage,
            children: /*#__PURE__*/_jsx(TextInput, {
              placeholder: text(i18nKey('input.placeholder')),
              onChange: this.onUrlChange,
              onBlur: this.onUrlBlur,
              value: url
            })
          })]
        }), /*#__PURE__*/_jsxs(DialogFooter, {
          children: [/*#__PURE__*/_jsx(Button, {
            use: "primary",
            onClick: this.onModalConfirm,
            disabled: !!(url && !isValidUrl),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('buttons.add')
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: this.onModalClose,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('buttons.cancel')
            })
          })]
        })]
      });
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        AddRedirectUrlModal: this.renderModal(),
        openAddRedirectUrlModal: this.onModalOpen
      }));
    }
  }
  AddRedirectUrlModal.wrappedComponen = WrappedComponent;
  return AddRedirectUrlModal;
}